export const BYSTADIUM_DOMAIN =
  process.env.NODE_ENV !== "production" ? "localhost" : ".bystadium.com";
